import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingShopOfferGroupById } from "../../balancingSelectors/selectBalancingPurchaseOfferGroups";
import { selectCurrentDialogGift } from "../../selectors/selectTournamentRewards";
import { utilOffers } from "../../utils/utilOffers";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionShopRequestPurchase } from "../shop/actionShop";
import { ShopPaymentPage } from "../shop/components/ShopPaymentPage";
var _DialogConfirmBuyTournamentSpecialOffer = function (_a) {
    var getOfferProps = _a.getOfferProps, onClose = _a.onClose, onClick = _a.onClick;
    return (React.createElement("div", { className: "flex flex--guts modal-overlay", onClick: onClose },
        React.createElement("div", { onClick: function (event) { return event.stopPropagation(); } },
            React.createElement(ShopPaymentPage, { offer: getOfferProps(onClick, onClose) }))));
};
var mapState = function (state) {
    var currentGift = selectCurrentDialogGift(state);
    var fullGroupOffer = selectBalancingShopOfferGroupById(currentGift.id);
    var shopPackage = utilOffers.matchPurchaseOfferGroupToWebCatalog(fullGroupOffer, state.shop.catalog.packages || []);
    var providers = [];
    shopPackage.providerIds.forEach(function (id) {
        providers.push({
            countryCode: shopPackage.currencyCode,
            id: id,
            type: "default",
        });
    });
    return {
        getOfferProps: function (onBuyClick, onCloseClick) {
            return utilOffers.convertOfferGroupToOffer(fullGroupOffer, shopPackage, onCloseClick, onBuyClick, providers);
        },
    };
};
var mapDispatch = function (dispatch) { return ({
    onClick: function (offer, selectedProvider) {
        return dispatch(actionShopRequestPurchase(offer, selectedProvider));
    },
    onClose: function () { return dispatch(actionModalClose(IdModal.ConfirmBuyTournamentSpecialOffer)); },
}); };
export var DialogConfirmBuyTournamentSpecialOffer = connect(mapState, mapDispatch)(_DialogConfirmBuyTournamentSpecialOffer);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/DialogConfirmBuyTournamentSpecialOffer.tsx
// module id = 2941
// module chunks = 3